/* Component Dependencies */
var univNavHamburgerMenuTemplate = require('templates/univNavHamburgerMenu.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'univNavHamburgerMenu',
  template: {
    'univNavHamburgerMenu': univNavHamburgerMenuTemplate
  }
});